import Types from "./Types";

export const getAllSubjectsRequest = (body) => ({
  type: Types.GET_SUPERADMIN_SUBJECTS_REQUEST,
  payload: body,
});

export const getAllSubjectsSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_SUBJECTS_SUCCESS,
  payload: data,
});

export const getAllSubjectsFail = () => ({
  type: Types.GET_SUPERADMIN_SUBJECTS_FAIL,
});

export const editSubjectRequest = (formData, action) => ({
  type: Types.EDIT_SUPERADMIN_SUBJECT_REQUEST,
  payload: formData,
  action: action,
});

export const editSubjectSuccess = (data) => ({
  type: Types.EDIT_SUPERADMIN_SUBJECT_SUCCESS,
  payload: data,
});

export const editSubjectFail = () => ({
  type: Types.EDIT_SUPERADMIN_SUBJECT_FAIL,
});

export const restrictSubjectRequest = (formData, action) => ({
  type: Types.RESTRICT_SUPERADMIN_SUBJECT_REQUEST,
  payload: formData,
  action: action,
});

export const restrictSubjectSuccess = (data) => ({
  type: Types.RESTRICT_SUPERADMIN_SUBJECT_SUCCESS,
  payload: data,
});

export const restrictSubjectFail = () => ({
  type: Types.RESTRICT_SUPERADMIN_SUBJECT_FAIL,
});
export const asqueraSubjectRequest = (formData, action) => ({
  type: Types.ASQUARA_SUPERADMIN_SUBJECT_REQUEST,
  payload: formData,
  action: action,
});

export const asqueraSubjectSuccess = (data) => ({
  type: Types.ASQUARA_SUPERADMIN_SUBJECT_SUCCESS,
  payload: data,
});

export const asqueraSubjectFail = () => ({
  type: Types.ASQUARA_SUPERADMIN_SUBJECT_FAIL,
});
export const activeSubjectRequest = (formData, action) => ({
  type: Types.ACTIVE_SUPERADMIN_SUBJECT_REQUEST,
  payload: formData,
  action: action,
});

export const activeSubjectSuccess = (data) => ({
  type: Types.ACTIVE_SUPERADMIN_SUBJECT_SUCCESS,
  payload: data,
});

export const activeSubjectFail = () => ({
  type: Types.ACTIVE_SUPERADMIN_SUBJECT_FAIL,
});
//LOADING
export const addSubjectLoading = (isLoading) => ({
  type: Types.ADD_SUPERADMIN_SUBJECTS_LOADING,
  payload: isLoading,
});

// Create Subject
export const createSubjectRequest = (formData, action) => ({
  type: Types.CREATE_SUPERADMIN_SUBJECT_REQUEST,
  payload: formData,
  action: action,
});

export const createSubjectSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_SUBJECT_SUCCESS,
  payload: {
    data,
  },
});

export const createSubjectFail = () => ({
  type: Types.CREATE_SUPERADMIN_SUBJECT_FAIL,
});

export const deleteSubjectRequest = (id) => ({
  type: Types.DELETE_SUPERADMIN_SUBJECT_REQUEST,
  payload: id,
});

export const deleteSubjectSuccess = (id) => ({
  type: Types.DELETE_SUPERADMIN_SUBJECT_SUCCESS,
  payload: id,
});

export const deleteSubjectFail = () => ({
  type: Types.DELETE_SUPERADMIN_SUBJECT_FAIL,
});
